import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  slider: {
    width: '276px',
    backgroundColor: palette.shades[200],
    border: "1px solid ".concat(palette.shades[500]),
    borderRadius: '2px',
    display: 'inline-flex',
    padding: '6px 24px'
  }
});
export default useStyles;